import Market from './Market.js';

class Util {
    static DownloadFile(blob, filename) {
        if (window.navigator && window.navigator.msSaveBlob) {
            window.navigator.msSaveBlob(blob, filename);
        } else {
            let a = document.createElement("a");
            document.body.appendChild(a);
            a.style.cssText = "display: none";
            let tempURL = window.URL.createObjectURL(blob);
            a.href = tempURL;
            a.download = filename;
            a.click();
            window.URL.revokeObjectURL(tempURL);
            a.remove();
        }
    }

    static InActiveAll(node) {
        if (node) {
            if (node.active) {
                node.active = false;
            }

            if (node.children) {
                for (let i = 0; i < node.children.length; i++) {
                    Util.InActiveAll(node.children[i]);
                }
            }
            else if(Array.isArray(node)){
                for (let i = 0; i < node.length; i++) {
                    Util.InActiveAll(node[i]);
                }
            }
        }
    }

    static UnToggledAll(node) {
        if (node) {
            if (node.toggled) {
                node.toggled = false;
            }

            if (node.children) {
                for (let i = 0; i < node.children.length; i++) {
                    Util.UnToggledAll(node.children[i]);
                }
            }
        }
    }

    static FindAncestorNodes(treeData, currentPage, home){
        let ancestorNodes = [];
        if(currentPage!= null){
            ancestorNodes.unshift(currentPage);
            let parentNode = this.FindParentNode(treeData, currentPage.id);
            while(parentNode != null && parentNode.id !== 'examples'){
                ancestorNodes.unshift(parentNode);
                parentNode = this.FindParentNode(treeData, parentNode.id);
            }
        }
        ancestorNodes.unshift({
            name: home
        });
        return ancestorNodes;
    }

    static FindParentNode = function(treeData, nodeId){
        let result = null;

        var findPar = function(node, id, parentNode){
            if (node.id && id) {

                if(id && id.lastIndexOf('.') != -1){
                    id = id.substring(id.lastIndexOf('.') + 1);
                }

                if (node.id.toLowerCase() === id.toLowerCase()) {
                    result = parentNode;
                }
                else {
                    if (node.children) {
                        for (let i = 0; i < node.children.length; i++) {
                            findPar(node.children[i], id, node);
                        }
                    }
                }
            }

            return result;
        }
       return findPar(treeData, nodeId);
    }

    static FindNodeById(node, id) {
        let result = null;

        if (node.id) {

            if(id && id.lastIndexOf('.') != -1){
                id = id.substring(id.lastIndexOf('.') + 1);
            }

            if (node.id.toLowerCase() === id.toLowerCase()) {
                result = node;
            }
            else {
                if (node.children) {
                    for (let i = 0; i < node.children.length; i++) {
                        let sNode = Util.FindNodeById(node.children[i], id);
                        if (sNode != null) {
                            node.toggled = true;
                            result = sNode;
                        }
                    }
                }
            }
        }

        if (result) {
            Util.InActiveAll(node);
            result.active = true;
        }

        return result;
    }
    

    static LoadJSONFile(filePath, callBackFunction, exceptionHandler) {
        if (filePath) {
            fetch(filePath).then(function (response) {
                if (response.ok) {
                    return response.json();
                }
            }).then(function (jsonData) {
                return callBackFunction(jsonData);
            }).catch(function (error) {
                if (exceptionHandler) {
                    return exceptionHandler(error);
                }
                else {
                    console.log('There has been a problem getting the json file: ' + error.message);
                }
            });
        }
    }

    static GetCurrentCultureName() {
        return Market.CurrentMarket.CurrentCulture;
    }

}

export default Util;
